



























































import Vue from 'vue'
import BaseImage from '@/common/components/BaseImage.vue'
import RadioName from '@/product/components/RadioName.vue'
import {
  ProductColorPattern,
  FormattedColorPatternOption
} from '@/product/types'
import {
  SVG_PLACEHOLDER_IMAGES,
  COLOR_TYPES,
  COLOR_PATTERN_EXPLANATIONS
} from '@/common/constants'
import { COLOR_PATTERN_TYPES } from '@/common/constants'

export default Vue.extend({
  components: { BaseImage, RadioName },
  props: {
    option: {
      type: Object as () => ProductColorPattern,
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    imagePlaceholder() {
      return SVG_PLACEHOLDER_IMAGES.COLOR_PATTERN_IMAGE
    },
    formattedOption(): FormattedColorPatternOption {
      return this.getPrintingOptionData(this.option)
    },
    isPlainOption(): boolean {
      return this.option.colorPattern.type === COLOR_PATTERN_TYPES.PLAIN
    },
    disableOption(): boolean {
      // do not allow EMBROIDERY_TEXT with library design
      return (
        !!this.$store.state.stockLibraryDesign.uuid &&
        this.option.colorPattern.type === COLOR_PATTERN_TYPES.EMBROIDERY_TEXT
      )
    }
  },
  methods: {
    getPrice(input: string): string {
      return (input.match(/(?=\¥)(.*?)(?=\()/g) || [''])[0]
    },
    getDescription(input: string): string {
      return this.disableOption
        ? `${this.option.colorPattern.displayName}とライブラリ画像の併用はできません。刺繍をご希望の場合は刺繍（画像）をお選びください。`
        : input.substring(input.indexOf('\n'), input.length)
    },
    getIsFullColor(input: string): boolean {
      if (
        COLOR_TYPES.SINGLE_COLOR.includes(
          input.substring(0, input.indexOf('@')).trim()
        )
      ) return false
      return true
    },
    getPrintingOptionData(option: ProductColorPattern): FormattedColorPatternOption {
      const optionName = option.colorPattern.displayName
      const optionLead = option.colorPattern.lead

      return {
        id: option.id,
        displayName: optionName,
        image: option.colorPattern.image,
        price: this.getPrice(optionLead),
        explanation:
          COLOR_PATTERN_EXPLANATIONS[
            optionName as keyof typeof COLOR_PATTERN_EXPLANATIONS
          ],
        description: this.getDescription(optionLead),
        colorType: this.getIsFullColor(optionLead)
          ? {
              name: COLOR_TYPES.FULL_COLOR,
              icon: require('common/icon-full-color.svg')
            }
          : {
              name: COLOR_TYPES.SINGLE_COLOR,
              icon: require('common/icon-single-color.svg')
            }
      }
    },
    onSelectColorPattern(option: ProductColorPattern) {
      this.$emit('update', option)
    }
  }
})
